import { useMemo, useRef } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import * as THREE from "three";

const Cloud = ({ count, radius, color, size, speed, scroll }) => {
  const ref = useRef();
  const positions = useMemo(() => {
    const arr = new Float32Array(count * 3);
    for (let i = 0; i < count; i++) {
      const r = radius * Math.cbrt(Math.random());
      const theta = Math.random() * Math.PI * 2;
      const phi = Math.acos(2 * Math.random() - 1);
      arr[i * 3] = r * Math.sin(phi) * Math.cos(theta);
      arr[i * 3 + 1] = r * Math.sin(phi) * Math.sin(theta);
      arr[i * 3 + 2] = r * Math.cos(phi);
    }
    return arr;
  }, [count, radius]);

  useFrame((state, delta) => {
    if (!ref.current) return;
    const s = scroll ? scroll.get() : 0;
    ref.current.rotation.y += delta * speed;
    ref.current.rotation.x = s * 1.2 + Math.sin(state.clock.elapsedTime * 0.08) * 0.06;
  });

  return (
    <points ref={ref}>
      <bufferGeometry>
        <bufferAttribute attach="attributes-position" args={[positions, 3]} />
      </bufferGeometry>
      <pointsMaterial
        size={size}
        color={color}
        transparent
        opacity={0.85}
        sizeAttenuation
        depthWrite={false}
        blending={THREE.AdditiveBlending}
      />
    </points>
  );
};

export default function StarField({ scroll }) {
  return (
    <div className="absolute inset-0" aria-hidden="true">
      <Canvas camera={{ position: [0, 0, 6], fov: 60 }} dpr={[1, 1.5]} gl={{ alpha: true, antialias: true }}>
        <Cloud count={1400} radius={9} color="#ffffff" size={0.035} speed={0.02} scroll={scroll} />
        <Cloud count={400} radius={7} color="#D4AF37" size={0.05} speed={-0.014} scroll={scroll} />
        <Cloud count={220} radius={6} color="#F06BA8" size={0.06} speed={0.01} scroll={scroll} />
      </Canvas>
    </div>
  );
}
